import React, { FC } from 'react';

import { alpha, styled } from '@mui/material/styles';

import CloseInCircleAnimatedIcon from '~/assets/icons/CloseInCircleAnimatedIcon';
import TickOutlinedAnimatedIcon from '~/assets/icons/TickOutlinedAnimatedIcon';

interface AnimatedCheckmarkProps {
  noBackground?: boolean;
  correct?: boolean;
}

const AnimatedCheckmark: FC<AnimatedCheckmarkProps> = ({ correct, noBackground, ...rest }) => {
  return (
    <Wrapper correct={correct} noBackground={noBackground} {...rest}>
      {correct ? (
        <StyledTickOutlinedAnimatedIcon data-testid="tickOutlinedIcon" />
      ) : (
        <StyledCloseInCircleAnimatedIcon data-testid="closeInCircleIcon" />
      )}
    </Wrapper>
  );
};

export default AnimatedCheckmark;

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'noBackground' && prop !== 'correct',
})<{ noBackground?: boolean; correct?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 4px;
  box-sizing: content-box;
  border-radius: 50%;
  background: ${({ theme, noBackground, correct }) =>
    !noBackground &&
    alpha(correct ? theme.palette.common.green : theme.palette.common.status.error, 0.3)};
`;
const StyledTickOutlinedAnimatedIcon = styled(TickOutlinedAnimatedIcon)`
  width: 100%;
  height: 100%;
`;
const StyledCloseInCircleAnimatedIcon = styled(CloseInCircleAnimatedIcon)`
  width: 100%;
  height: 100%;
`;
